export enum EventTypeEnum {
  registration_to_webinar = 'registration_to_webinar',
  webinar_start = 'webinar_start',
}
